import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Typography } from '@comparethemarketau/manor-typography';

import { SectionTitle } from '../common/section_title';
import { ContentCard } from '../common/content_card';
import { ContentTitleLogo } from '../common/content_title_logo';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';
import { Separator } from '../../products/products/common/separator';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: theme.spacing[40]
    },
    providerInfo: {
        marginTop: theme.spacing[24]
    },
    separatorBox: {
        marginTop: theme.spacing[16],
        marginBottom: theme.spacing[16]
    },
    title: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey600,
        marginBottom: theme.spacing[12],
        textTransform: 'uppercase',
    },
    subTitle: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700,
        marginBottom: theme.spacing[12]
    },
    contentText: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.normal,
        marginBlockStart: theme.spacing[24]
    },
    unerwriterName: {
        fontWeight: theme.fontWeight.black
    }
}));

const _AboutThisProvider = ({
    providerCode,
    providerName,
    className,
    config,
    productUnderwriterName,
    productUnderwriterAcn,
    productUnderwriterAfsl,
    productUnderwriterAbn,
    providerBlurb
}) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { id, label } = config;
    return (
        <div id={id} className={classNames('test-policyProduct-aboutThisProvider', classes.container, className)}>
            <SectionTitle label={label} />
            <ContentCard>
                <ContentTitleLogo providerCode={providerCode} title={providerName} />
                <Typography component="div" className={classes.providerInfo}>
                    {' '}
                    {providerBlurb}
                    {' '}
                </Typography>
                <Separator type="horizontal" className={classes.separatorBox} />
                <Typography className={classNames(classes.title)}>
                    Underwriter
                </Typography>
                <Typography className={classNames(classes.subTitle)}>
                    The underwriter determines the cover, eligibility guidelines and premiums.
                    These companies take on the financial risk related to insurance.
                </Typography>
                <Typography className={classes.contentText}>
                    {`This policy from ${providerName} is underwritten by `}
                    <span className={classes.unerwriterName}>{productUnderwriterName}</span>
                    {', an Australian insurance company regulated by APRA and a member of the Insurance Council of Australia.'}
                </Typography>
                <Typography className={classes.contentText}>
                    {productUnderwriterAcn ? `ACN: ${productUnderwriterAcn}` : `ABN: ${productUnderwriterAbn}`}
                    {`,  AFS Licence No: ${productUnderwriterAfsl}`}
                </Typography>
            </ContentCard>
        </div>
    );
};

_AboutThisProvider.propTypes = {
    className: PropTypes.string,
    config: PropTypes.object.isRequired,

    providerName: PropTypes.string.isRequired,
    providerCode: PropTypes.string.isRequired,
    productUnderwriterName: PropTypes.string,
    productUnderwriterAcn: PropTypes.string,
    productUnderwriterAfsl: PropTypes.string,
    productUnderwriterAbn: PropTypes.string,
    providerBlurb: PropTypes.string
};

const AboutThisProvider = withQuoteFlatten(_AboutThisProvider);

export { AboutThisProvider };
